<template>
  <div class="mt-2">
    <v-layout>
      <v-flex>
        <v-btn flat @click="cancelProduct">
          <em class="fas fa-chevron-left mr-1" />
          {{ $t('Back') }}
        </v-btn>
      </v-flex>
    </v-layout>
    <h3 class="headline mt-3">{{ $t('Add new product') }}</h3>

    <!-- Category -->
    <div class="form-control mt-3" :class="{ 'has-error': errors.has('categoryInput') }">
      <label for="categoryInput" class="caption"
        >{{ $t('Category') }} <span class="red--text">*</span></label
      >
      <select-category
        :pageid="pageid"
        v-model="category"
        data-vv-name="categoryInput"
        data-vv-as="Category"
        :selected="currentCategory"
        @onChangeCategory="onChangeCategory"
        v-validate="'required'"
      ></select-category>
      <span class="text-error" v-show="errors.has('categoryInput')">
        {{ errors.first('categoryInput') }}
      </span>
    </div>

    <div class="col s6 px-0 mt-2">
      <div class="form-control" :class="{ 'has-error': errors.has('menberLevelInput') }">
        <label for="menberLevelInput" class="caption"
          >{{ $t('Member Level') }} <span class="red--text">*</span></label
        >
        <v-radio-group
          v-validate="'required'"
          v-model="memberLevel"
          :data-vv-as="$t('Member Level')"
          name="menberLevelInput"
          row
        >
          <v-radio color="primary" label="New Member" value="new"></v-radio>
          <v-radio color="primary" label="Silver Member" value="silver"></v-radio>
          <v-radio color="primary" label="Gold Member" value="gold"></v-radio>
        </v-radio-group>
        <span class="text-error" v-show="errors.has('menberLevelInput')">
          {{ errors.first('menberLevelInput') }}
        </span>
      </div>
    </div>

    <!-- Product -->
    <div class="pb-3 form-control" :class="{ 'has-error': errors.has('uploadImage') }">
      <!-- <upload-multiple-file
        v-model="productImages"
        :max="10"
        data-vv-name="uploadMultipleFile"
        data-vv-as="Preview Image"
      ></upload-multiple-file> -->

      <uploadfile
        :data-vv-as="$t('uploadImage')"
        name="Product Image"
        v-validate="'required'"
        v-model="product.photourl"
        style="max-width: 250px"
      ></uploadfile>

      <span class="text-error" v-show="errors.has('uploadImage')">
        {{ errors.first('uploadImage') }}
      </span>
    </div>
    <div class="form-control" :class="{ 'has-error': errors.has('nameInput') }">
      <label class="caption" for="nameInput"
        >{{ $t('Product Name') }} <span class="red--text">*</span></label
      >
      <input
        type="text"
        class="form-control"
        ref="name"
        id="nameInput"
        name="nameInput"
        :data-vv-as="$t('Product Name')"
        aria-describedby="name"
        :placeholder="$t('Product Name')"
        v-model="product.name"
        @blur="$set(product, 'name', noSpaceAndSpecial($event))"
        v-validate="'required'"
      />
      <span class="text-error" v-show="errors.has('nameInput')">
        {{ errors.first('nameInput') }}
      </span>
    </div>
    <div class="row">
      <div class="col s12"></div>
      <div class="col s12 px-0">
        <div
          class="form-group form-control"
          :class="{ 'has-error': errors.has('descriptionInput') }"
        >
          <div>
            <label for="descriptionInput" class="caption"
              >{{ $t('Product detail') }} <span class="red--text">*</span></label
            >
          </div>
          <textarea
            type="text"
            class="form-control"
            id="descriptionInput"
            name="descriptionInput"
            style="resize: vertical; min-height: 90px; width: 100%"
            :data-vv-as="$t('Product detail')"
            aria-describedby="description"
            :placeholder="$t('Product detail')"
            row="3"
            v-model="product.description"
            v-validate="'required'"
          ></textarea>
          <span class="text-error" v-show="errors.has('descriptionInput')">
            {{ errors.first('descriptionInput') }}
          </span>
        </div>
      </div>
      <div class="col s6 px-0">
        <div class="form-group form-control" :class="{ 'has-error': errors.has('EffectiveDate') }">
          <div>
            <label for="EffectiveDate" class="caption"
              >{{ $t('Effective Date') }} <span class="red--text">*</span></label
            >
          </div>
          <div>
            <v-layout row class="ma-0">
              <v-flex xs10>
                <datepicker
                  class="form-control"
                  v-model="selectedEffectiveDate"
                  name="EffectiveDate"
                  placeholder="DD/MM/YYYY"
                  v-validate="'required'"
                  :data-vv-as="$t('Effective Date')"
                ></datepicker>
              </v-flex>
              <v-flex>
                <v-btn @click="clearDateTime('selectedEffectiveDate')" icon>
                  <v-icon>delete</v-icon></v-btn
                >
              </v-flex>
            </v-layout>
            <span class="text-error" v-show="errors.has('EffectiveDate')">
              {{ errors.first('EffectiveDate') }}
            </span>
          </div>
        </div>
      </div>
      <div class="col s6 px-0">
        <div class="form-group form-control" :class="{ 'has-error': errors.has('EndDate') }">
          <div>
            <label for="EndDate" class="caption"
              >{{ $t('End Date') }} <span class="red--text">*</span></label
            >
          </div>
          <v-layout row class="ma-0">
            <v-flex xs10>
              <datepicker
                class="form-control"
                v-model="selectedEndDate"
                @selected="onSelectedEndDate"
                name="EndDate"
                placeholder="DD/MM/YYYY"
                v-validate="'required'"
                :data-vv-as="$t('End Date')"
              ></datepicker>
            </v-flex>
            <v-flex>
              <v-btn @click="clearDateTime('selectedEndDate')" icon> <v-icon>delete</v-icon></v-btn>
            </v-flex>
          </v-layout>
          <span class="text-error" v-show="errors.has('EndDate')">
            {{ errors.first('EndDate') }}
          </span>
        </div>
      </div>
      <div class="col s12 px-0 py-4">
        <div class="form-group">
          <div for="buttonActionInput" class="pb-2">Button Action</div>
          <v-btn-toggle v-model="buttonType" dense>
            <v-btn :value="'link'" style="width: 100px">
              <v-icon left style="margin-right: 4px !important"> link </v-icon>
              <span>Link</span>
            </v-btn>
            <v-btn :value="'text'" style="width: 100px">
              <em class="fas fa-align-left mr-2" />
              <span>Text</span>
            </v-btn>
          </v-btn-toggle>
        </div>
      </div>

      <div class="col s6 px-0 pr-2">
        <div class="form-control" :class="{ 'has-error': errors.has('buttonNameInput') }">
          <label class="caption" for="buttonNameInput">{{ $t('Button Name') }}</label>
          <input
            type="text"
            class="form-control"
            ref="name"
            id="buttonNameInput"
            name="buttonNameInput"
            :data-vv-as="$t('Button Name')"
            aria-describedby="name"
            :placeholder="$t('Button Name')"
            v-model="product.buttonname"
          />
          <span class="text-error" v-show="errors.has('buttonNameInput')">
            {{ errors.first('buttonNameInput') }}
          </span>
        </div>
      </div>
      <template v-if="buttonType == 'link'">
        <div class="col s6 px-0 pl-2">
          <div class="form-control" :class="{ 'has-error': errors.has('productUrlInput') }">
            <label class="caption" for="productUrlInput">{{ $t('Product Url') }}</label>
            <input
              type="text"
              class="form-control"
              ref="name"
              id="productUrlInput"
              name="productUrlInput"
              :data-vv-as="$t('Product Url')"
              aria-describedby="name"
              :placeholder="'http://producturl.com || https://producturl.com'"
              v-model="product.buttonurl"
            />
            <span class="text-error" v-show="errors.has('productUrlInput')">
              {{ errors.first('productUrlInput') }}
            </span>
          </div>
        </div>
      </template>
      <template v-if="buttonType == 'text'">
        <div class="col s6 px-0 pl-2">
          <div class="form-control" :class="{ 'has-error': errors.has('actionInput') }">
            <label class="caption" for="actionInput">{{ $t('Action') }}</label>
            <input
              type="text"
              class="form-control"
              ref="name"
              id="actionInput"
              name="actionInput"
              :data-vv-as="$t('Action')"
              aria-describedby="name"
              :placeholder="$t('Action')"
              v-model="product.buttonaction"
            />
            <span class="text-error" v-show="errors.has('actionInput')">
              {{ errors.first('actionInput') }}
            </span>
          </div>
        </div>
      </template>
    </div>

    <div class="text-xs-center" v-if="currentView == 'product'">
      <v-btn outline color="grey" @click="cancelProduct">{{ $t('cancel') }}</v-btn>
      <v-btn depressed color="primary" @click="saveProduct">{{ $t('Save') }}</v-btn>
    </div>
  </div>
</template>

<script>
import SelectCategory from '@/components/view/template/ecommerce/SelectCategory.vue'
import uploadfile from '@/components/elements/uploadfile'
import api from '@/api'
import UploadMultipleFile from '@/components/elements/UploadMultipleFile'
import { mapGetters } from 'vuex'
import goTo from 'vuetify/lib/components/Vuetify/goTo'
import datepicker from 'vuejs-datepicker'

export default {
  props: ['category', 'selectCategory', 'editData'],
  inject: ['$validator'],
  data: function () {
    return {
      currentView: 'product',
      productImages: [],
      product: {
        photourl: null,
        name: null,
        description: null,
        categoryid: null,
        buttonaction: '',
        buttonname: '',
        buttonurl: ''
      },
      memberLevel: '',
      selectedEffectiveDate: '',
      selectedEndDate: '',
      currentCategory: null,
      isEdit: false,
      buttonType: null
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    pageid: function () {
      return this.$store.state.selectedBot.pageid
    }
  },
  mounted: async function () {
    var vm = this
    // vm.$refs.name.focus();
    await this.$nextTick()

    goTo(0)

    if (Number.isInteger(vm.selectCategory)) {
      vm.currentCategory = vm.selectCategory
    } else {
      vm.currentCategory = vm.selectCategory[0]
    }

    if (vm.editData) {
      if (vm.editData.buttonurl !== '') {
        vm.buttonType = 'link'
      } else {
        vm.buttonType = 'text'
      }

      vm.memberLevel = vm.editData.producttype
      vm.product.photourl = vm.editData.photourl
      vm.product.name = vm.editData.name
      vm.product.description = vm.editData.description
      vm.product.categoryid = vm.editData.categoryid
      vm.product.buttonaction = vm.editData.buttonaction
      vm.product.buttonname = vm.editData.buttonname
      vm.product.buttonurl = vm.editData.buttonurl
      vm.selectedEffectiveDate = vm.editData.effectivedate
      vm.selectedEndDate = vm.editData.enddate
      vm.isEdit = true
      vm.currentCategory = vm.editData.categoryid
    } else {
      vm.buttonType = 'link'
    }

    document.addEventListener('keydown', (e) => {
      if (e.keyCode == 27) {
        vm.$emit('close')
      }
    })
  },
  components: {
    datepicker,
    SelectCategory: SelectCategory,
    uploadfile: uploadfile,
    UploadMultipleFile
  },
  methods: {
    clearDateTime(name) {
      if (name == 'selectedEffectiveDate') {
        this.selectedEffectiveDate = ''
      } else if (name == 'selectedEndDate') {
        this.selectedEndDate = ''
      }
    },
    onSelectedEndDate(value) {
      var vm = this

      if (moment(value).isBefore(vm.selectedEffectiveDate)) {
        vm.selectedEndDate = ''
      } else {
        vm.selectedEndDate = value
      }
    },
    cancelProduct: function () {
      this.product = {
        photourl: null,
        name: null,
        description: null,
        categoryid: null,
        buttonaction: 'url',
        buttonname: '',
        buttonurl: ''
      }
      this.memberLevel = ''
      this.selectedEffectiveDate = ''
      this.selectedEndDate = ''
      this.$emit('close')
    },
    onChangeCategory: function (payload) {
      this.currentCategory = payload
      this.product.categoryid = this.currentCategory
    },
    async saveProduct() {
      // return new Promise((resolve, reject) => {
      if (await this.$validator.validate()) {
        let vm = this
        let data = {
          pageid: vm.selectedBot.pageid,
          name: vm.product.name,
          photourl: vm.product.photourl,
          description: vm.product.description,
          categoryid: vm.product.categoryid,
          effectivedate: vm.selectedEffectiveDate,
          enddate: vm.selectedEndDate,
          buttonname: vm.product.buttonname,
          buttonaction: vm.product.buttonaction,
          buttonurl: vm.product.buttonurl,
          producttype: vm.memberLevel
        }

        if (!vm.isEdit) {
          api.postLamyProduct(data, function (error, response) {
            if (error) {
              return
            }

            vm.$emit('onAddProduct')
            vm.$emit('close')
            vm.cancelProduct()
            // resolve(response);
          })
        } else {
          var productId = this.editData.id
          Object.assign(data, { id: productId })

          api.putLamyProduct(data, function (error, response) {
            if (error) {
              return
            }

            vm.$emit('onSaveProduct')
            vm.$emit('close')
            vm.cancelProduct()
            // resolve(response);
          })
        }
      }

      // });
    }
  },
  watch: {
    selectCategory: function (newVal, oldVal) {
      var vm = this
      if (Number.isInteger(vm.selectCategory)) {
        vm.currentCategory = vm.selectCategory
      } else {
        vm.currentCategory = vm.selectCategory[0]
      }
    },
    buttonType: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.product.buttonname = ''
        this.product.buttonaction = ''
        this.product.buttonurl = ''
      }
    }
  }
}
</script>

<style scroped>
.caption {
  font-size: 14px !important;
}
.v-btn-toggle .v-btn.v-btn--active {
  background-color: #ff706b !important;
  border-color: #ff706b !important;
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/lamy/ModalPromotion.vue